import * as Yup from "yup";

import {
  withinChildBornInterval,
  withinDueDateInterval,
} from "./pregnantAndNewbornProductDetailsUtils";

import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { PregnantAndNewbornDetailsFormValues } from "./pregnantAndNewbornProductDetailsInterfaces";

export const validationSchema =
  () => (): Yup.ObjectSchema<PregnantAndNewbornDetailsFormValues> => {
    const { getText } = TextManager;
    const birthdayRequired = getText(
      "pregnantandnewbornform.validation.birthdate-required",
    );

    return Yup.object({
      childBorn: Yup.mixed<BooleanFormType>()
        .oneOf([BooleanFormType.TRUE, BooleanFormType.FALSE], "")
        .required(getText("pregnantandnewbornform.validation.childborn")),

      multipleChildren: Yup.mixed<BooleanFormType>()
        .oneOf([BooleanFormType.TRUE, BooleanFormType.FALSE], "")
        .required(
          getText("pregnantandnewbornform.validation.multiplechildren"),
        ),

      birthDate: Yup.date()
        .when(["childBorn"], {
          is: (childBorn: BooleanFormType) =>
            childBorn === BooleanFormType.TRUE,
          then: (schema) =>
            schema
              .test(
                "birthDate",
                getText(
                  "pregnantandnewbornform.validation.birthdate-child_is_born",
                ),
                (birthDate) => withinChildBornInterval(birthDate),
              )
              .typeError(birthdayRequired),
          otherwise: (schema) =>
            schema
              .test(
                "birthDate",
                getText(
                  "pregnantandnewbornform.validation.birthdate-child_is_not_born",
                ),
                (birthDate) => withinDueDateInterval(birthDate),
              )
              .typeError(birthdayRequired),
        })
        .required(birthdayRequired),
    }).defined();
  };
